module.exports = __webpack_public_path__ + "img/tc_white_color.8187c2a2.png";